import React, { useContext, useEffect } from 'react';
import RenderImageOptions from './RenderImageOptions';
import { ContextMetaInfo, ImageOptions as IImageOptions, OptionClickInfo, ResponseObj } from '../../../../types/caf';
import GlobalContext from '../../../../contexts/GlobalContext';

type Props = {
  optionsObj: ResponseObj;
  conversationId: string;
  handleOptionClick: (info: OptionClickInfo) => void;
  contextMetaInfo: ContextMetaInfo | {};
  isLastConversation: boolean;
};

const ImageOptions = (props: Props): JSX.Element => {
  // will shows either category images or item images
  const { globalContext } = useContext(GlobalContext);
  const imageList = props?.optionsObj.value as IImageOptions[];
  const { isLastConversation } = props;
  const defaultDispatchAction = props?.optionsObj?.dispatchAction;

  useEffect(() => {
    globalContext.gtm.setVirtualPage(props?.optionsObj?.virtualPage);
  }, []);

  return (
      <ul className="item-selection">
      {Array.isArray(imageList) && imageList?.map((item, index) => (
        <li key={index}
          className={`${(props.contextMetaInfo[props?.optionsObj.selectedKeyName]?.toLowerCase() === item?.label?.toLowerCase()) && (!isLastConversation) ? 'active' : ''}`}
          onClick={(): void => props.handleOptionClick({
            dispatchAction: item.dispatchAction || defaultDispatchAction,
            info: {
              label: item?.label,
              index: index,
              value: item?.value?.toLowerCase(),
              key: props?.optionsObj.selectedKeyName
            },
            conversationId: props.conversationId,
            eventDetails: props?.optionsObj?.eventDetails
          })}>
            {/* <img src={item.imageLink} alt={item.label} /> */}
            <RenderImageOptions imageLink={item?.imageLink}/>
            <div>{item?.value}</div>
        </li>
      ))}
    </ul>
  );
};

export default ImageOptions;
